<template>
  <div
    v-loading="loading"
    class="app-main-content"
    element-loading-text=""
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleTabClick">
        <el-tab-pane :label="$t('SystemMaintenance.IPWhitelist')" name="ipWhiteList">
          <ip-white-list ref="ipWhiteList" :lazy="true" />
        </el-tab-pane>
        <el-tab-pane
          :label="$t('SystemMaintenance.UserWhitelist')"
          name="userIpWhiteList"
        >
          <ip-white-list ref="userIpWhiteList" type="user" :lazy="true" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import ipWhiteList from './components/ipWhiteList'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'IpFilterConfig',
  components: {
    ipWhiteList,
    cargoAdvanceSelect
  },
  filters: {

  },
  data() {
    return {
      loading: false,
      activeTabName: 'ipWhiteList'
    }
  },
  computed: {

  },
  watch: {
  },
  mounted() {
  },
  methods: {
    handleTabClick(tab) {
      if (this.$refs[tab.name]) {
        this.$refs[tab.name].fetchList()
      }
    },
    onReady(params) {
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
